module.exports = __webpack_public_path__ + "static/media/gas-measuring-board.7a19c735.PNG";